import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 11.442a.583.583 0 0 1-.583-.584V7.234A.59.59 0 0 1 8 6.65a.59.59 0 0 1 .583.584v3.624a.583.583 0 0 1-.583.583M8 5.723a.59.59 0 0 0 .583-.583.583.583 0 1 0-1.166 0A.59.59 0 0 0 8 5.723"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 13.484a5.485 5.485 0 1 0 0-10.97 5.485 5.485 0 0 0 0 10.97m6.667-5.485A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }